import { addTokenInUrl, getAwsAssets } from "@src/utils";
import {
  COMMON_DEEPLINK_ACTIONS,
  USER_AGENT_STRING,
} from "@src/utils/constants";
import {
  hitDeeplinkPerformAction,
  hitDeeplinkExecutedV2,
} from "@src/utils/hitDeeplink";
import { t } from "i18next";
import { Image } from "@src/components/Image";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import ShareIcon from "../ShareIcon";
import {
  setSocialLinksDataAction,
  showShareContentViaBottomSheetAction,
} from "@src/components/BottomSheets/store/actions";
import { directDeepLink } from "@src/common/deepLinks";
import ShareCourseViaBottomSheet from "@src/components/BottomSheets/components/ShareCourseViaBottomSheet/ShareCourseViaBottomSheet";
import { hitContentDeeplinkOld } from "../../../Content/helpers/hitContentDeeplink";

function LiveClassCard({
  liveEmblem,
  scheduleEmblem,
  trialEmblem,
  title,
  time,
  scheduleTime,
  index,
  deeplink,
  isAgora,
  emblem4,
  socialLinks,
  isLiveClassShareable,
}) {
  const [disableButton, setDisableButton] = useState(true);
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);
  const deviceType = useSelector(
    (state) => state?.persistedDataReducer?.deviceType
  );

  const classTime = moment(time).format("MMM DD, YYYY hh:mm A");

  useEffect(() => {
    if (scheduleTime) {
      if (scheduleTime - new Date().getTime() <= 86400000) {
        timeoutRef.current = setTimeout(() => {
          setDisableButton(false);
        }, scheduleTime - new Date().getTime());
      }
    }
    return () => clearTimeout(timeoutRef?.current);
  }, [index, scheduleTime]);

  let emblems = [
    disableButton ? scheduleEmblem : liveEmblem,
    ...(trialEmblem ? [trialEmblem] : []),
  ];
  const token = useSelector((state) => state?.persistedDataReducer?.userToken);

  const renderFooterButton = () => {
    return (
      <button
        className="LiveClassCard__Bottom--CTA"
        disabled={disableButton}
        onClick={() => {
            deeplink?.screen === "ZOOM_WEBINAR_LIVE_JOIN"
            ? 
              hitContentDeeplinkOld("UTIL_WEBVIEW", {paramOne: addTokenInUrl(deeplink?.paramOne, token)}, true, true)
            : isAgora
              ? hitDeeplinkExecutedV2(
                JSON.stringify(deeplink),
                JSON.stringify(deeplink)
              )
              : hitDeeplinkPerformAction(
                COMMON_DEEPLINK_ACTIONS.OPEN_GO_LIVE,
                JSON.stringify(deeplink),
                JSON.stringify(deeplink)
              );
        }}
      >
        {deeplink
          ? t(
              "components.Tabs.Overview.components.UpcomingLive.LiveClassCard.join",
              "Join Class"
            )
          : null}
      </button>
    );
  };

  const renderCourseTime = () => {
    return (
      <div className="LiveClassCard__Bottom--Time">
        <Image
          src={getAwsAssets("Clock.svg", "Overview")}
          alt="X"
          width="12px"
          height="12px"
          layout="fixed"
          objectFit="cover"
        />
        <span>{classTime}</span>
      </div>
    );
  };

  const renderFooterNew = () => {
    return (
      <div className="LiveClassCard__Bottom">
        <div className="LiveClassCard__Bottom--Wrap">
          {emblem4?.text ? (
            <div className="LiveClassCard__Bottom--Assignee">
              <Image
                src={emblem4?.icon}
                alt="X"
                width="12px"
                height="12px"
                layout="fixed"
                objectFit="cover"
              />
              <span style={{ color: emblem4?.color }}>{emblem4?.text}</span>
            </div>
          ) : null}
          {disableButton && renderCourseTime()}
        </div>
        {!disableButton && renderFooterButton()}
      </div>
    );
  };

  const renderFooterOld = () => {
    return (
      <div className="LiveClassCard__Bottom">
        <div className="LiveClassCard__Bottom--Wrap">{renderCourseTime()}</div>
        {renderFooterButton()}
      </div>
    );
  };

  // console.log("SETTIMEOUT--deeplink", deeplink);

  return (
    <div className="LiveClassCard">
      <div className="LiveClassCard__Top">
        <div className="LiveClassCard__Tags">
          {emblems?.map((emblem, i) => (
            <span key={i} className="LiveClassCard__Tags--Emblem">
              <img
                src={emblem?.icon}
                alt="X"
                height="20px"
                style={{ marginRight: "6px" }}
              />
              {/* {emblem?.text} */}
            </span>
          ))}
        </div>
        {isLiveClassShareable ? (
          <ShareIcon
            onClick={() => {
              // newWebEngage("course_share_click", {
              //   action: "Single Share Click",

              // });
              deviceType == USER_AGENT_STRING.IOS
                ? directDeepLink(
                    {
                      action: "ACTION_SHARE_COURSE",
                    },
                    "ACTION_SHARE_COURSE",
                    false
                  )({ socialLinks })
                : (() => {
                    dispatch(setSocialLinksDataAction(socialLinks));
                    dispatch(showShareContentViaBottomSheetAction(true));
                  })();
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div className="LiveClassCard__Title">{title}</div>
      {emblem4 ? renderFooterNew() : renderFooterOld()}
    </div>
  );
}

export default LiveClassCard;
